<div class="turnkey-cost-accordion-header">
  <div class="turnkey-cost-accordion-header-text">
    {{ turnkeyCost().cost }}
  </div>
  @if (!!turnkeyCost().id) {
    <div>
      <button
        mat-mini-fab
        class="turnkey-cost-accordion-header-btn"
        (click)="handleOpenHistory($event)"
      >
        <mat-icon class="turnkey-cost-accordion-header-btn-icon">
          history
        </mat-icon>
      </button>
      @if (isEditModeActive()) {
        <button
          mat-mini-fab
          class="turnkey-cost-accordion-header-btn"
          (click)="handleDelete($event, turnkeyCost().id)"
        >
          <mat-icon class="turnkey-cost-accordion-header-btn-icon">
            delete
          </mat-icon>
        </button>
      }
    </div>
  }
</div>
